@if (hasNotifications()) {
<div class="notification-container"></div>
}
